import { Config } from '../types';

const defaultConfig: Config = {
  ENV: 'default',

  // SENTRY
  // SENTRY_DSN: 'https://a1c191a390da447697f76fc7547b1bb4@sentry.io/1417052',
  SENTRY_ENV: 'development',

  // GTM
  GTM_ENABLED: false,

  // CLICK HOUSE
  CLICK_HOUSE_ENABLED: true,

  // GHOST
  GHOST_URL: 'https://ghost.reas.cz',
  GHOST_CONTENT_KEY: '7f0617108ac3404ad1b5e93a18',

  /**
   * API
   * - LEADER
   */
  API_URL: 'https://apis-staging.reas.cz',

  RE_CAPTCHA_SITE_KEY: '6Ld12XwjAAAAABSUxsLOLPCkD8c60ejLmYfgCzdN',

  DISABLED_FEATURES: {},
};

export default defaultConfig;
